export default __webpack_public_path__ + "static/media/SDJ.1cb24cda.png";